import { USDI_API_URL } from '../../configs/config';

export async function persistSkipAddEmailPrompt(walletAddress) {
    if (!walletAddress) {
        return false;
    }

    try {
        const response = await fetch(
            `${USDI_API_URL}/update?table=usdi_holders_info_table_solana&key=address&value=${walletAddress}`,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ skip_email_prompt: true }),
            }
        );

        return response.ok;
    } catch (error) {
        console.error('Failed to persist skip email prompt preference:', error);
        return false;
    }
}
